import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const ConfiguracaoPixAutomaticoList = props => <DefaultDataTable data={props} />;
